define('plugins/musicfavourite/nls/eavis/confirmation',{
    'en-gb': {
        'confirmation': {
            'added': 'Added. Check out ',
            'link': 'Your Playlist',
            'afterLink': '.'
        }
    },
    'cy-gb': { //WELSH
        'confirmation': {
            'added': 'Ychwanegwyd. ',
            'link': 'Ewch i\'ch Rhestr Chwarae',
            'afterLink': '.'
        }
    },
    'ga-gb': { //IRISH
        'confirmation': {
            'added': 'Curtha leis. Amharc ar ',
            'link': 'Do Sheinnliosta',
            'afterLink': '.'
        }
    },
    'gd-gb': { //SCOTTISH
        'confirmation': {
            'added': 'Air a chur ris. Seall ri ',
            'link': 'do chlàr-ciùil',
            'afterLink': '.'
        }
    }
});

